export default __webpack_public_path__ + "static/media/rnr-sports-table-8-cn.56448f7c.webp";